import { addStyles } from 'ethcss'
import { colors, IStyles } from 'theme'

const styles: IStyles = {
    wrapper: {
        position: 'relative',
    },
    selectActionBtn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: `1px solid ${colors.greyLight}`,
        padding: '8px 12px',
        borderRadius: 5,
        cursor: 'pointer',
    },
    menu: {
        position: 'absolute',
        top: 40,
        left: 0,
        right: 0,
        borderRadius: 5,
        boxShadow: '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08)',
        background: colors.white,
        zIndex: 1,
    },
    active: {
        borderColor: `${colors.blueAccent} !important`,
    },
}

addStyles(styles)
export default styles
